import {
  SEARCH_NETWORK_ERROR,
  SEARCH_NO_RESULTS_ERROR,
  TOKEN_EXPIRED,
} from 'Utils/constants/genericConstants';

export const getErrorMsg = (errors) => {
  const errorList = errors?.graphQLErrors?.[0]?.extensions?.errors;
  let errorMsg;
  if (errorList?.[0]?.code === '401') {
    errorMsg = TOKEN_EXPIRED;
  } else if (errorList?.[0]?.code > 399 && errorList?.[0]?.code < 600) {
    errorMsg = SEARCH_NETWORK_ERROR;
  } else {
    let msgList = errorList?.map((errorObj) => {
      let errorMsg = errorObj?.message;
      if (errorObj?.message?.length > 80) {
        if (errorObj?.code === 'M3032' || errorObj?.code === 'EG1014') {
          errorMsg = SEARCH_NO_RESULTS_ERROR;
        } else {
          errorMsg = SEARCH_NETWORK_ERROR;
        }
      }
      return errorMsg;
    });
    errorMsg = msgList?.join(',');
  }
  if (!errorMsg) {
    if (errorList?.[0]?.code === 'M3032' || errorList?.[0]?.code === 'EG1014') {
      errorMsg = SEARCH_NO_RESULTS_ERROR;
    } else {
      errorMsg = SEARCH_NETWORK_ERROR;
    }
  }
  return errorMsg;
};

const joinMessages = (list) =>
  Array.isArray(list)
    ? list
        .map((e) => (typeof e === 'string' ? e : e?.message))
        .filter(Boolean)
        .join(', ')
    : '';

/**
 * Turns whatever an SR create/update call hands back — an ApolloError, a
 * `{code, message}[]` list from updateServiceRequest, or a plain string —
 * into one readable message for the SnackBar, instead of passing raw objects
 * (which render as blank/"[object Object]") or a generic network error.
 */
export const getSRErrorMessage = (error, fallback: string): string => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  const extensionErrors = error?.graphQLErrors?.[0]?.extensions?.errors;
  if (extensionErrors?.[0]?.code === '401') return TOKEN_EXPIRED;
  return (
    joinMessages(extensionErrors) ||
    joinMessages(error?.graphQLErrors) ||
    joinMessages(Array.isArray(error) ? error : error?.errors) ||
    fallback
  );
};

/** Error message for a failed createSR response, or null when it succeeded. */
export const getCreateSRError = (resp, fallback: string): string | null => {
  if (resp?.data?.createServiceRequest && !resp?.error) return null;
  return getSRErrorMessage(resp?.error || resp?.errors, fallback);
};
